export default "__VITE_ASSET__DDyeDNxY__"